import * as firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FB_API_KEY,
  authDomain: "cacaoenbytes-23b12.firebaseapp.com",
  databaseURL: "https://cacaoenbytes-23b12.firebaseio.com",
  projectId: "cacaoenbytes-23b12",
  storageBucket: "cacaoenbytes-23b12.appspot.com",
  messagingSenderId: "665489759386",
  appId: "1:665489759386:web:0fa923da3955c4ef781323"
};

const fb = firebase.initializeApp(firebaseConfig);
const fs = firebase.storage();

async function uploadTask(id: number | string, table: string, imageFile: any) {
  return new Promise(function(resolve, reject) {
    const storageRef = fb
      .storage()
      .ref("images/" + table + "/" + id + imageFile.name);
    const uploadTask = storageRef.put(imageFile);

    uploadTask.on(
      "state_changed",
      null,
      error => {
        reject(error);
      },
      async () => {
        await uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
          resolve(downloadURL);
        });
      }
    );
  });
}

async function deleteTask(fileURL: string) {
  const fileREF = fs.refFromURL(fileURL);
  let deleted = false;

  await fileREF
    .delete()
    .then(function() {
      deleted = true;
    })
    .catch(function(error) {
      console.log(error);
      deleted = false;
    });

  return deleted;
}

export { uploadTask, deleteTask };
